<!--
 * @Author: p_fy
 * @Date: 2019-07-18 17:22:46
 * @LastEditors: pfy
 * @LastEditTime: 2019-09-24 18:16:02
 * @Description: 我的预约列表，状态：普仓、罐区。
 -->
<template>
  <div class="content-container">
    <div class="supply-head">
      <div class="slider-list" >
        <div :class="{ 'selected': !state}" @click="toggleState(0)" class="item">普仓</div>
        <div :class="{ 'selected': state}" @click="toggleState(1)" class="item">罐区</div>
      </div>
      <!-- 查询表单  -->
    </div>

    <!--存入表格数据-->
    <article class="operations" />

    <div v-loading="viewManager.loading" class="supply-data">
      <div class="supply-data-header">
        <ul>
          <!-- <li>
            <input v-model="allSelection" type="checkbox" @change="selection()">
          </li> -->
          <li>租单名称</li>
          <li>储存类型</li>
          <li>库房位置</li>
          <li v-if="!state">可租用面积</li>
          <li v-if="state">罐区容积</li>
          <li>期望租金</li>
          <li>对方意向</li>
          <li>操作</li>
        </ul>
      </div>
      <div ref="data-body" class="supply-data-body">
        <template v-if="!viewManager.loading && data.length < 1">
          <div class="no-data-info">
            <font>暂无匹配数据</font>
          </div>
        </template>
        <template v-for="(supply, index) of data">
          <div :key="index" class="data-item">
            <ul>
              <!-- <li>
                <input v-model="supply.selection" type="checkbox" @change="change()">
              </li> -->
              <el-tooltip class="item" effect="dark" :content="`${supply.supplyName}`" placement="top">
                <li>{{ supply.supplyName }}</li>
              </el-tooltip>
              <el-tooltip v-if="!state" class="item" effect="dark" :content="`${supply.storageTypeLabel}`" placement="top">
                <li>{{ supply.storageTypeLabel }}</li>
              </el-tooltip>
              <el-tooltip v-if="state" class="item" effect="dark" :content="`${supply.tankTypeLabel}`" placement="top">
                <li>{{ supply.tankTypeLabel }}</li>
              </el-tooltip>
              <el-tooltip class="item" effect="dark" :content="`${supply.storageLocationLabel}`" placement="top">
                <li>{{ supply.storageLocationLabel }}</li>
              </el-tooltip>
              <el-tooltip v-if="!state" class="item" effect="dark" :content="`${supply.rentableArea}m²`" placement="top">
                <li>{{ supply.rentableArea }}m²</li>
              </el-tooltip>
              <el-tooltip v-if="state" class="item" effect="dark" :content="`${supply.potArea}m³`" placement="top">
                <li>{{ supply.potArea }}m³</li>
              </el-tooltip>
              <el-tooltip class="item" effect="dark" :content="`${supply.expectPrice}${!state ? '元/m²/天' : '元/罐·天'}`" placement="top">
                <li>{{ supply.expectPrice }}{{ !state ? '元/m²/天' : '元/罐/天' }}</li>
              </el-tooltip>
              <el-tooltip class="item" effect="dark" :content="`${supply.statusLabel}`" placement="top">
                <li>{{ supply.statusLabel }}</li>
              </el-tooltip>
              <li>
                <el-button v-if="supply.publishStatus == '3'" style="color: #be2316 !important;" type="text">已成交</el-button>
                <el-button v-else type="text" style="color: #66b1ff !important;" @click="deal(supply)">成交</el-button>
                <el-divider direction="vertical" />
                <el-button plain size="small" @click="supplyInfo(supply)">
                  详情
                  <i :class="{'expand': !supply.hidden}" class="el-icon-d-arrow-right" />
                </el-button>
              </li>
              <!-- <el-button v-if="state" type="text" @click="popRecommendList(supply.id)">仓库推荐</el-button>
                <el-divider v-if="state" direction="vertical" />
                <el-button type="text" @click="edit(supply)">编辑</el-button>
                <el-divider direction="vertical" />
                <el-button type="text" @click="del(supply)">删除</el-button>
                <el-divider direction="vertical" />
                <el-button plain size="small" @click="supplyInfo(supply)">
                  详情
                  <i :class="{'expand': !supply.hidden}" class="el-icon-d-arrow-right" />
                </el-button> -->
            </ul>
            <span v-if="supply.sureFlag > 0" class="data-item-sureflag" @click="sureflagClick(supply)">最近7天有成交记录</span>
            <storeSupplyInfo v-if="!supply.hidden && !state" style="position: initial;" :supply="supply" />
            <tankSupplyInfo v-if="!supply.hidden && state" style="position: initial;" :supply="supply" />
          </div>
        </template>
      </div>
      <div class="supply-data-pagination">
        <el-pagination
          :current-page="pagination.pageNo"
          :total="pagination.total"
          :page-size="pagination.pageSize"
          layout="prev, pager, next, jumper,total, sizes"
          @current-change="changeCurrent"
          @size-change="changeSize"
        />
      </div>
    </div>
    <store-deal ref="dealDialog" :deal-type="!state ? '1' : '2' " :deal-manager="dealManager.visible" :deal-data="dealManager.data" :demand-data="null" @close="dealManager.close" @closeSuccess="dealManager.close" />
  </div>
</template>

<script>
// 普仓供应详情
import storeSupplyInfo from '../store-supply-list/components/storeSupplyInfo'
// 罐区供应详情
import tankSupplyInfo from '../tank-supply-list/components/tankSupplyInfo'
import storeDeal from '../components/storeDeal'
import { findPageAppointment } from '@/api/personal/store/my-appointment/myAppointment'
import { tableClass } from '@/api/personal/store/store-supply-list/StoreSupplyParam'

const table = tableClass.getTable() // 引用表格参数类

export default {
  name: 'MyAppointment',
  components: {
    storeSupplyInfo,
    tankSupplyInfo,
    storeDeal
  },
  data: function() {
    return {
      data: [],
      area: [],
      allSelection: false,
      // 表格数据
      pagination: table.Page,
      queryParams: {
      },
      dealManager: {
        visible: false,
        data: {},
        close: () => {
          this.loadData()
          this.dealManager.visible = false
        }
      },
      state: false,
      viewManager: {
        loading: true
      }
    }
  },
  computed: {
    getPublishState() {
      return this.state ? 2 : 1
    }
  },
  watch: {
    state: function() {
      this.loadData()
    }
  },
  created: function() {
    if (this.$route.params.noticeId != undefined) {
      // console.log('消息通知过来的数据', 'id:' + this.$route.params.noticeId, 'type:' + this.$route.params.noticeMark)
    }
    (async() => {
      this.loadData()
    })()
  },
  methods: {
    // 点击成交过的提示
    sureflagClick(data) {
      console.log(data)
      this.$router.push({
        name: 'OrderList',
        params: { data: data }
      })
    },
    // 列表切换
    // toggleState() {
    //   this.state = !this.state
    //   // this.loadData()
    // },
    toggleState(state) {
      this.state = state
      this.loadData()
    },
    // 子项选择
    change() {
      this.allSelection = this.data.every(i => i.selection)
    },
    // 全选
    selection() {
      this.data.forEach(i => {
        if (i.selection !== this.allSelection) {
          i.selection = !i.selection
        }
      })
    },
    // 监听分页
    changeSize(size) {
      this.pagination.pageSize = size
      this.loadData()
    },
    // 监听分页
    changeCurrent(current) {
      this.pagination.pageNo = current
      this.loadData()
    },
    // 初始化查询
    loadData() {
      this.viewManager.loading = true
      this.queryParams.demandType = this.getPublishState
      this.queryParams.publishStatus = '2'
      this.loadTableData()
    },
    // 成交
    deal(item) {
      this.dealManager.data = item
      this.dealManager.visible = true
    },
    // 详情展示
    supplyInfo(supply) {
      if (supply.hidden) {
        this.data.map(res => {
          res.hidden = true
          return res
        })
      }
      supply.hidden = !supply.hidden
    },
    // 查询
    loadTableData() {
      const params = Object.assign(this.pagination, this.queryParams)
      findPageAppointment(params)
        .then(data => {
          console.log(data.result.rows)
          // console.log(data.result.rows.sureFlag)
          this.data = data.result.rows.map(res => {
            res.hidden = true
            res.selection = false
            return res
          })
          this.pagination.total = data.result.total
        })
        .catch(error => {
          this.pagination.total = this.data.length
          console.error(error)
        })
        .finally(() => {
          this.viewManager.loading = false
        })
    }
  }
}
</script>
<style scoped lang="scss">
@import "@/styles/standardColor.scss";

$main-color: #be2316;

.content-container {
  .supply-head {
    padding: 1rem;
    border-style: solid;
    border-width: 0 0 1px 0;
    border-color: #f1f1f1;
    background-color: #ffffff;
    .slider-list {
      display: block;
      margin: 0 0;
      height: 36px;
      overflow: auto;
      white-space: nowrap;
      border-bottom: 1px solid #f1f1f1;
      &::-webkit-scrollbar {
        height: 0px !important;
        width: 0px !important;
      }
      &::-moz-scrollbar {
        height: 0px !important;
        width: 0px !important;
      }
      .item {
        // height: 35px;
        height: calc(100% - 1px);
        display: inline-block;
        width: 100px;
        font-size: 16px;
        font-weight: 600;
        line-height: 35px;
        margin-right: 12px;
        border-bottom: 1px solid rgba(0, 0, 0, 0);
        text-align: center;
        transition: all 1s;
        color: black;
        cursor: pointer;
        &.selected {
          border-bottom: 1px solid $main-color;
          transition: all 1s;
          color: $main-color;
        }
      }
    }
    .supply-head-form {
      padding-top: 1rem;
      display: flex;
      .fileds {
        flex: 0 1 75%;
        /deep/ .el-form-item {
          label:after {
            content: "";
          }
        }
      }
      .buttons {
        flex: 0 1 25%;
        display: inherit;
        align-items: center;
        justify-content: center;
      }
    }
  }

  .operations {
    margin: 16px 0px;
  }

  .supply-data {
    .supply-data-header {
      color: $main-color;
      font-weight: bold;
      background-color: #ffffff;
      height: 45px;
      margin-bottom: 1rem;
      ul {
        display: flex;
        flex-wrap: nowrap;
        height: 100%;
        width: calc(100% - 16px);
        padding: 8px 8px;
        box-sizing: content-box;
        li {
          font-size: 15px;
          min-width: 50px;
          height: 100%;
          line-height: 29px;
          text-align: center;
          &:nth-child(1) {
            flex-basis: 14%;
          }
          &:nth-child(2) {
            flex-basis: 14%;
          }
          &:nth-child(3) {
            flex-basis: 14%;
          }
          &:nth-child(4) {
            flex-basis: 14%;
          }
          &:nth-child(5) {
            flex-basis: 14%;
          }
          &:nth-child(6) {
            flex-basis: 14%;
          }
          &:nth-child(7) {
            flex-basis: 16%;
          }
          // &:nth-child(7) {
          //   flex-basis: 15.8%;
          // }
        }
      }
    }

    .supply-data-body {
      position: relative;
      min-height: 420px;
      .no-data-info {
        background-color: #fff;
        width: 100%;
        text-align: center;
        margin-top: 8px;
        height: 48px;
        line-height: 48px;
        font-size: 15px;
      }
    //       @keyframes slider-in {
    //   from {
    //     transform: translateX(100%);
    //     opacity: 0.1;
    //   }
    //   to {
    //     transform:translateX(0);
    //     opacity: 1;
    //   }
    // }
    //  @keyframes slider-out {
    //   from {
    //     transform: translateX(0);
    //     opacity: 0.1;
    //   }
    //   to {
    //     transform:translateX(-100%);
    //     opacity: 1;
    //   }
    // }
    // &.slider-in {
    //   visibility:visible !important;
    //   animation: slider-in 1s ease-in;
    // }
    // &.slider-out {
    //   visibility:visible !important;
    //   animation: slider-out 1s ease-out;
    // }
    // visibility: hidden;

      .data-item {
        margin: 8px 0px;
        box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
        border: 1px solid #ebeef5;
        position: relative;
        .data-item-sureflag{
          position: absolute;
          font-size: 12px;
          right: 27px;
          top: 8px;
          color: #aaa;
          cursor: pointer;
        }
        ul {
          display: flex;
          flex-wrap: nowrap;
          min-height: 56px;
          width: calc(100% - 16px);
          padding: 8px 8px;
          position: relative;
          background-color: white;
          *::selection {
            background-color: rgba(0, 0, 0, 0) !important;
          }
          li {
            font-size: 15px;
            min-width: 50px;
            height: 100%;
            margin: auto auto;
            position: relative;
            text-align: center;
            &:nth-child(1) {
              flex-basis: 14%;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
              padding: 0px 0.3%;
            }
            &:nth-child(2) {
              flex-basis: 14%;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
              padding: 0px 0.3%;
            }
            &:nth-child(3) {
              flex-basis: 14%;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
              padding: 0px 0.3%;
            }
            &:nth-child(4) {
              flex-basis: 14%;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
              padding: 0px 0.3%;
            }
            &:nth-child(5) {
              flex-basis: 14%;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
              padding: 0px 0.3%;
            }
            &:nth-child(6) {
              flex-basis: 14%;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
              padding: 0px 0.3%;
            }
            &:nth-child(7) {
              flex-basis: 16%;
            }
            // &:nth-child(7) {
            //   flex-basis: 15.8%;
            // }
            &:last-child {
              .el-button:first-child {
                color: #be2316 !important;
              }
              .el-button:nth-child(3) {
                color: #e6a23c !important;
              }
              .el-button:nth-child(4) {
                color: black !important;
              }
              /deep/ .el-button.is-plain {
                background-color: white;
                color: #be2316;
                border-color: #be2316;
                padding: 7px 4px !important;
                width: 56px;
                span > i {
                  transition: 1s all;
                  transform: rotateZ(90deg);
                  &.expand {
                    transform: rotateZ(-90deg);
                  }
                }
              }
            }
          }
        }
        /deep/ .supply-item-details {
          border: 1px solid #ebeef5;
          z-index: 0;
        }
      }
    }
    .supply-data-pagination {
      width: calc(100% - 32px);
      margin-top: 24px;
      padding: 16px 0px;
      background-color: white;
    }
  }

  .invitation-data {
    .invitation-data-header {
      color: $main-color;
      font-weight: bold;
      background-color: #ffffff;
      height: 45px;
      margin-bottom: 1rem;
      ul {
        display: flex;
        flex-wrap: nowrap;
        height: 100%;
        width: calc(100% - 16px);
        padding: 8px 8px;
        box-sizing: content-box;
        li {
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
          font-size: 15px;
          min-width: 50px;
          height: 100%;
          line-height: 29px;
          text-align: center;
          &:nth-child(1) {
            flex-basis: 15%;
          }
          &:nth-child(2) {
            flex-basis: 10%;
          }
          &:nth-child(3) {
            flex-basis: 10%;
          }
          &:nth-child(4) {
            flex-basis: 10%;
          }
          &:nth-child(5) {
            flex-basis: 10%;
          }
          &:nth-child(6) {
            flex-basis: 10%;
          }
          &:nth-child(7) {
            flex-basis: 10%;
          }
          &:nth-child(8) {
            flex-basis: 10%;
          }
          &:nth-child(9) {
            flex-basis: 15%;
          }
          &:nth-child(10) {
            flex-basis: 15%;
          }
        }
      }
    }
    .invitation-data-body {
      position: relative;
      .data-item {
        margin: 8px 0px;
        box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
        border: 1px solid #ebeef5;
        position: relative;
        ul {
          display: flex;
          flex-wrap: nowrap;
          height: 56px;
          width: calc(100% - 16px);
          padding: 8px 8px;
          position: relative;
          background-color: white;
          li {
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
            font-size: 15px;
            min-width: 50px;
            height: 100%;
            line-height: 64px;
            text-align: center;
            &:nth-child(1) {
              flex-basis: 15%;
            }
            &:nth-child(2) {
              flex-basis: 10%;
            }
            &:nth-child(3) {
              flex-basis: 10%;
            }
            &:nth-child(4) {
              flex-basis: 10%;
            }
            &:nth-child(5) {
              flex-basis: 10%;
            }
            &:nth-child(6) {
              flex-basis: 10%;
            }
            &:nth-child(7) {
              flex-basis: 10%;
            }
            &:nth-child(8) {
              flex-basis: 10%;
            }
            &:nth-child(9) {
              flex-basis: 15%;
            }
            &:nth-child(10) {
              flex-basis: 15%;
            }
          }
        }
        /deep/ .supply-item-details {
          border: 1px solid #ebeef5;
          z-index: 0;
        }
      }
    }
    .invitation-data-pagination {
      width: calc(100% - 32px);
      margin-top: 24px;
      padding: 16px 0px;
      background-color: white;
    }
  }

  .bid-data {
    .bid-data-header {
      color: $main-color;
      font-weight: bold;
      background-color: #ffffff;
      height: 45px;
      margin-bottom: 1rem;
      ul {
        display: flex;
        flex-wrap: nowrap;
        height: 100%;
        width: calc(100% - 16px);
        padding: 8px 8px;
        box-sizing: content-box;
        li {
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
          font-size: 15px;
          min-width: 50px;
          height: 100%;
          line-height: 29px;
          text-align: center;
          &:nth-child(1) {
            flex-basis: 10%;
          }
          &:nth-child(2) {
            flex-basis: 15%;
          }
          &:nth-child(3) {
            flex-basis: 8%;
          }
          &:nth-child(4) {
            flex-basis: 10%;
          }
          &:nth-child(5) {
            flex-basis: 10%;
          }
          &:nth-child(6) {
            flex-basis: 10%;
          }
          &:nth-child(7) {
            flex-basis: 7%;
          }
          &:nth-child(8) {
            flex-basis: 10%;
          }
          &:nth-child(9) {
            flex-basis: 10%;
          }
          &:nth-child(10) {
            flex-basis: 10%;
          }
          &:nth-child(11) {
            flex-basis: 10%;
          }
        }
      }
    }
    .bid-data-body {
      position: relative;
      .data-item {
        margin: 8px 0px;
        box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
        border: 1px solid #ebeef5;
        position: relative;
        ul {
          display: flex;
          flex-wrap: nowrap;
          height: 56px;
          width: calc(100% - 16px);
          padding: 8px 8px;
          position: relative;
          background-color: white;
          li {
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
            font-size: 15px;
            min-width: 50px;
            height: 100%;
            line-height: 64px;
            text-align: center;
            &:nth-child(1) {
              flex-basis: 10%;
            }
            &:nth-child(2) {
              flex-basis: 15%;
            }
            &:nth-child(3) {
              flex-basis: 8%;
            }
            &:nth-child(4) {
              flex-basis: 10%;
            }
            &:nth-child(5) {
              flex-basis: 10%;
            }
            &:nth-child(6) {
              flex-basis: 10%;
            }
            &:nth-child(7) {
              flex-basis: 7%;
            }
            &:nth-child(8) {
              flex-basis: 10%;
            }
            &:nth-child(9) {
              flex-basis: 10%;
            }
            &:nth-child(10) {
              flex-basis: 10%;
            }
            &:nth-child(11) {
              flex-basis: 10%;
            }
          }
        }
        /deep/ .supply-item-details {
          border: 1px solid #ebeef5;
          z-index: 0;
        }
      }
    }
    .bid-data-pagination {
      width: calc(100% - 32px);
      margin-top: 24px;
      padding: 16px 0px;
      background-color: white;
    }
  }

  .recommend-data {
    .recommend-data-header {
      color: $main-color;
      font-weight: bold;
      background-color: #ffffff;
      height: 45px;
      margin-bottom: 1rem;
      ul {
        display: flex;
        flex-wrap: nowrap;
        height: 100%;
        width: calc(100% - 16px);
        padding: 8px 8px;
        box-sizing: content-box;
        li {
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
          font-size: 15px;
          min-width: 50px;
          height: 100%;
          line-height: 29px;
          text-align: center;
          &:nth-child(1) {
            flex-basis: 10%;
          }
          &:nth-child(2) {
            flex-basis: 10%;
          }
          &:nth-child(3) {
            flex-basis: 10%;
          }
          &:nth-child(4) {
            flex-basis: 10%;
          }
          &:nth-child(5) {
            flex-basis: 10%;
          }
          &:nth-child(6) {
            flex-basis: 10%;
          }
          &:nth-child(7) {
            flex-basis: 10%;
          }
          &:nth-child(8) {
            flex-basis: 10%;
          }
          &:nth-child(9) {
            flex-basis: 10%;
          }
          &:nth-child(10) {
            flex-basis: 10%;
          }
        }
      }
    }
    .recommend-data-body {
      position: relative;
      .data-item {
        margin: 8px 0px;
        box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
        border: 1px solid #ebeef5;
        position: relative;
        ul {
          display: flex;
          flex-wrap: nowrap;
          height: 56px;
          width: calc(100% - 16px);
          padding: 8px 8px;
          position: relative;
          background-color: white;
          li {
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
            font-size: 15px;
            min-width: 50px;
            height: 100%;
            line-height: 64px;
            text-align: center;
            &:nth-child(1) {
              flex-basis: 10%;
            }
            &:nth-child(2) {
              flex-basis: 10%;
            }
            &:nth-child(3) {
              flex-basis: 10%;
            }
            &:nth-child(4) {
              flex-basis: 10%;
            }
            &:nth-child(5) {
              flex-basis: 10%;
            }
            &:nth-child(6) {
              flex-basis: 10%;
            }
            &:nth-child(7) {
              flex-basis: 10%;
            }
            &:nth-child(8) {
              flex-basis: 10%;
            }
            &:nth-child(9) {
              flex-basis: 10%;
            }
            &:nth-child(10) {
              flex-basis: 10%;
            }
          }
        }
        /deep/ .supply-item-details {
          border: 1px solid #ebeef5;
          z-index: 0;
        }
      }
    }
    .recommend-data-pagination {
      width: calc(100% - 32px);
      margin-top: 24px;
      padding: 16px 0px;
      background-color: white;
      width: 100%;
    }
  }
}
</style>
